// extracted by mini-css-extract-plugin
export var button = "_bi-0";
export var icon = "_bi-1";